import { Box, Chip, Fade } from '@mui/material'

function TitleBox(props: TitleBoxProps) {
  const { title, chip, count, shouldCount } = props
  const shouldRender = shouldCount && count > 0

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between' }}>
      {title}
      {chip && <Chip size="small" color="primary" label={chip.text} />}
      {shouldRender && (
        <Fade in={true}>
          <Chip size="small" color="primary" label={count} />
        </Fade>
      )}
    </Box>
  )
}

type TitleBoxProps = {
  title: string
  chip?: { text: string; flag?: string | undefined }
  count: number
  shouldCount: boolean
}

export default TitleBox
